import "./contact.css";
import ContactForm from "../../components/contact-form/contact-form";
import { Trans, useTranslation } from "react-i18next";
export default function Contact() {
  const { t } = useTranslation();

  const scrollToForm = () => {
    const el = document.getElementById("contactForm");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="contact-us-section">
      <div className="contact-form">
        <h6 className="contact-us-heading">{t("Contact Us")}</h6>
        <div className="contact-form-section">
            <h1>
              <Trans i18nKey={"Have a Vision? Let's Talk!"}>Have a Vision? Let's Talk! <br/></Trans></h1>
            <p>{t("We're happy to have you here, we look forward to work with you soon")}</p>
        </div>
        <ContactForm />
      </div>
      <div className="get-in-touch-section">
        <div>
          <h1>{t("Feel Free To Get In Touch")}</h1>
          <p>
            {t("With close to Two Decades of experience, we can deliver great results for your business with a professional approach and processes.")}
          </p>
        </div>

        <div className="info-cards-grid">
          <div className="info-card info-card-cta">
            <div>
              <h3>{t("Ready to Connect?")}</h3>
              <p>{t("We're excited to hear from you and look forward to working with you.")}</p>
            </div>
            <button type="button" className="cta-btn" onClick={scrollToForm}>
              {t("Get in touch")}
            </button>
          </div>

          <div className="info-card">
            <div className="info-card-icon">
              <i className="fa-solid fa-phone"></i>
            </div>
            <span className="info-card-label">{t("Phone")}</span>
            <p className="info-card-value">USA: <a href="tel:+16504279816">+1 6504279816</a></p>
            <p className="info-card-value">India: <a href="tel:+919381362469">+91 9381362469</a></p>
            <p className="info-card-value">Germany: <a href="tel:+4915129035145">+49 15129035145</a></p>
          </div>

          <div className="info-card">
            <div className="info-card-icon">
              <i className="fa-solid fa-envelope"></i>
            </div>
            <span className="info-card-label">{t("Email Address")}</span>
            <a href="mailto:contact@sigvion.com" className="info-card-value email">contact@sigvion.com</a>
          </div>

          <div className="info-card address-card">
            <span className="info-card-label">US</span>
            <h3>USA</h3>
            <p>
              805 Marbella Vista way,<br/>
              Leander, TX, 78641<br/>
              USA
            </p>
          </div>

          <div className="info-card address-card">
            <span className="info-card-label">IN</span>
            <h3>India</h3>
            <p>
              #308, DSL ABACUS IT Park,<br/>
              Industrial Development Area,<br/>
              Uppal, Secunderabad, Telangana, India
            </p>
          </div>

          <div className="info-card address-card">
            <span className="info-card-label">DE</span>
            <h3>Germany</h3>
            <p>
              Hinterer Rosengarten 24,<br/>
              97253 Gaukönigshofen<br/>
              Germany
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
